import {Typography} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React, {useCallback, useState} from 'react'
import type {FeedbackReason} from 'src/api/types'
import {tagToUrl} from 'src/shared/utils'

import {classes} from './ComplimentReason.styles'

type Props = {
  data: FeedbackReason
  selected: boolean
  onClick: Function
}

const formatComplimentLabel = (str: string) => {
  const words = str.split(' ')
  return `${words.slice(0, words.length - 1).join(' ')}\n${words.slice(-1)}`
}

const ComplimentReason: React.FC<Props> = ({data, onClick, selected = false}) => {
  const [activeImgLoaded, setActiveImgLoaded] = useState<boolean>(false)
  const [inactiveImgLoaded, setInactiveImgLoaded] = useState<boolean>(false)
  const {title, icon, reason_id: id} = data
  const handleReasonClick = useCallback(() => onClick(id), [id, onClick])

  return (
    <div className={classes.root} onClick={handleReasonClick}>
      <div
        className={clsx(
          classes.imageDefault,
          selected && classes.imageDefaultSelected,
          ((selected && activeImgLoaded) || (!selected && inactiveImgLoaded)) && classes.imageCustom,
        )}
      >
        {icon?.active && (
          <img
            alt=""
            className={clsx(icon.active, selected && activeImgLoaded && classes.visible)}
            data-e2e={`compliment-reason-${id}`}
            onLoad={() => setActiveImgLoaded(true)}
            src={tagToUrl(icon.active)}
          />
        )}
        {icon?.inactive && (
          <img
            alt=""
            className={clsx(icon.inactive, !selected && inactiveImgLoaded && classes.visible)}
            onLoad={() => setInactiveImgLoaded(true)}
            src={tagToUrl(icon.inactive)}
          />
        )}
      </div>
      <Typography className={clsx(classes.label, selected && classes.labelSelected)} variant="caption1">
        {formatComplimentLabel(title)}
      </Typography>
    </div>
  )
}

export default ComplimentReason
